<template>
  <div class="index">
    <!-- <div class="box"></div> -->
    	<div class="nodataCont">
        <img src="../../assets/img/nodataimg.png" />
      </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
        noDatas:null
    }
  },
  // 注册组件
  components: {

  },
  mounted() {
    this.noDatas = this.$route.query.insert
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {


  },
  methods: {

  }
}
</script>

<style scoped>
  .box{
    height:20px
  }
  .nodataCont{
    background: #fff;
    text-align: center;
  }
  .nodataCont img{
    margin: 50px auto;
  }
</style>



// WEBPACK FOOTER //
// src/views/noDatas/noDatas.vue